import * as types from './mutations-type'

export default {
  [types.setShow] (state, value) {
    state.show = value
  }
}
